"use client";
import { useEffect } from "react";

const InspectionPrevention = () => {
  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Disable common dev tool shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {
      // Disable F12 (Dev Tools)
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+I (Dev Tools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+C (Inspect Element)
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+U (View Source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        return false;
      }
      // Disable F11 (Fullscreen)
      if (e.key === 'F11') {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+K (Firefox Dev Tools)
      if (e.ctrlKey && e.shiftKey && e.key === 'K') {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Alt+I (Some browsers)
      if (e.ctrlKey && e.altKey && e.key === 'I') {
        e.preventDefault();
        return false;
      }
    };

    // Prevent drag and drop to avoid opening files in dev tools
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
      return false;
    };

    // Prevent selection for additional protection
    const handleSelectStart = (e: Event) => {
      // Allow selection in input fields and textareas
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.contentEditable === 'true') {
        return true;
      }
      e.preventDefault();
      return false;
    };

    // Override console methods to make debugging harder
    const noop = () => {};
    const originalConsole = { ...console };
    console.log = noop;
    console.warn = noop;
    console.error = noop;
    console.info = noop;
    console.debug = noop;
    console.table = noop;
    console.group = noop;
    console.groupEnd = noop;

    // Prevent opening dev tools via window.open or other methods
    const originalOpen = window.open;
    window.open = function(url?: string | URL, target?: string, features?: string) {
      // Block attempts to open dev tools related URLs
      if (url && typeof url === 'string' && (
        url.includes('chrome-devtools://') ||
        url.includes('devtools://') ||
        url.includes('about:blank')
      )) {
        return null;
      }
      return originalOpen.call(this, url, target, features);
    };

    // Add CSS to prevent text selection globally (except for inputs)
    const style = document.createElement('style');
    style.textContent = `
      body {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
      input, textarea, [contenteditable="true"] {
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text;
      }
      /* Prevent dragging images and links */
      img, a {
        -webkit-user-drag: none;
        -moz-user-drag: none;
        user-drag: none;
      }
    `;
    document.head.appendChild(style);

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu, false);
    document.addEventListener('keydown', handleKeyDown, false);
    document.addEventListener('dragstart', handleDragStart, false);
    document.addEventListener('selectstart', handleSelectStart, false);

    // Cleanup function
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu, false);
      document.removeEventListener('keydown', handleKeyDown, false);
      document.removeEventListener('dragstart', handleDragStart, false);
      document.removeEventListener('selectstart', handleSelectStart, false);

      // Restore console methods
      Object.assign(console, originalConsole);

      // Restore window.open
      window.open = originalOpen;

      // Remove added styles
      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    };
  }, []);

  return null; // This component doesn't render anything
};

export default InspectionPrevention;